import { writable } from 'svelte/store';

export const riskLevels = [
    {
        "level": 1,
        "overall": 0.001,
        "neurosurgicalInterventionRisk": 0.001,
        "intubationRisk": 0.001,
        "deathRisk": 0.001
    },
    {
        "level": 2,
        "overall": 0.0098,
        "neurosurgicalInterventionRisk": 0.0076,
        "intubationRisk": 0.0033,
        "deathRisk": 0
    },
    {
        "level": 3,
        "overall": 0.0269,
        "neurosurgicalInterventionRisk": 0.0161,
        "intubationRisk": 0.0188,
        "deathRisk": 0
    },
    {
        "level": 4,
        "overall": 0.1184,
        "neurosurgicalInterventionRisk": 0.1184,
        "intubationRisk": 0.0132,
        "deathRisk": 0
    },
    {
        "level": 5,
        "overall": 0.3510,
        "neurosurgicalInterventionRisk": 0.3413,
        "intubationRisk": 0.0240,
        "deathRisk": 0.0024
    }
];



export const data = writable({
    /**Depressed_Fx*/
    largeDepressedFracture: null,
    /**Finding6*/
    epiduralHematoma: false,
    /**Finding13*/
    subduralHematoma: false,
    /**Finding7*/
    extraAxialHematoma: null,
    /**Unsure Hematoma */
    unsureHematoma: false,
    /**contusionICH*/
    cerebralContusion: null,
    /**Finding9*/
    midlineShift: null,
    /**GCSTotal variable */
    initialGcsScore: -1,
    subarachnoidHemorrhage: null,

    inappropriateUse: null
});
